<template>
	<BottomSheet
		title=""
		v-model="openProductExternalDetail"
        :show-cart-icon="false"
		:height="'80%'"
		@close="onClose"
		:loading="loading"
        class="product-external-detail__modal"
	>
		<div class="product-external-detail" v-if="productExternalDetail">
			<div class="product-external-detail__image flex-center">
				<img :src="getImage" />
			</div>
			<h5 class="product-external-detail__title">{{ productExternalDetail.name }}</h5>
			<div
				v-if="productExternalDetail.description"
				class="product-external-detail__description"
			>
				<p class="product-external-detail__description--label">Description</p>
				<p class="product-external-detail__description--content">
					{{ productExternalDetail.description }}
				</p>
			</div>
		</div>
		<template #action>
			<div class="product-external-detail__action">
				<button
					:disabled="loading"
					class="product-external-detail__btn-view"
					@click="viewProduct"
				>
					<span class="loading product-external-detail__loading" v-if="loading"></span>
					<span v-else>{{ viewBtnText }}</span>
				</button>
			</div>
		</template>
	</BottomSheet>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from "vue";
import BottomSheet from "../shared/BottomSheet.vue";
import { useCartIntegration } from "@/vue/composables/useCartIntegration";
import { useToast } from "~/vue/composables/useToast";
import { computed } from "@vue/reactivity";

const {
	openProductExternalDetail,
	openProductList,
	productExternalDetail,
	loading,
    viewBtnText
} = useCartIntegration();
const { toast } = useToast();

const quantity = ref(1);

const getImage = computed(() => {
	return productExternalDetail.value.image;
});

async function viewProduct() {
	window.open(productExternalDetail.value.productLink, "_blank");
}

function onClose() {
	if (!openProductList.value) {
		openProductList.value = true;
	}
}
</script>
